import { createContext, useContext, type ReactNode } from 'react';
import type { Engine } from './engine';

const EngineContext = createContext<Engine | null>(null);

export const EngineProvider = ({ engine, children }: { engine: Engine; children: ReactNode }) => (
  <EngineContext value={engine}>{children}</EngineContext>
);

export const useEngine = (): Engine => {
  const engine = useContext(EngineContext);
  if (!engine) throw new Error('useEngine must be used inside <EngineProvider>');
  return engine;
};
